module.exports = __webpack_public_path__ + "static/3dprinting-a32a8614ee5139723bf38f399357de8c.jpg";